export default __webpack_public_path__ + "static/media/m_engineering_card17_1.7b8982d9.png";